import { throttle } from "lodash";

function thorInview($parse) {
    return {
        restrict: "A",
        require: "?^^thorInViewContainer",
        link: (scope, elem, attrs)  => {
            const viewportOffset = 1200;
            let lastVisibleState = false;

            const updateVisibility = onVisibilityChange(elem, visible => {
                lastVisibleState = visible;
                applyExpression(lastVisibleState, false);
            });

            const updatePlaceholderVisibility = onVisibilityChange(elem, visible => {
                applyExpression(lastVisibleState, visible);
            });

            updateVisibility();

            scope.$on("inview.update", () => {
                updateVisibility();
            });

            scope.$on("inview.placeholder-update", () => {
                updatePlaceholderVisibility();
            });

            function applyExpression(cardVisibility, placeholderVisibility) {
                const expression = $parse(attrs.thorInView);
                scope.$applyAsync(() => {
                    expression(scope, {
                        "$inView": cardVisibility,
                        "$placeholderInView": placeholderVisibility
                    });
                });
            }

            function isElementInViewport (el) {
                const rect = el.getBoundingClientRect();

                return (
                    rect.top >= 0 - viewportOffset &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + viewportOffset &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth) + 1
                );
            }

            function onVisibilityChange (el, callback) {
                let oldVisible;
                return () => {
                    const visible = isElementInViewport(el[0]);
                    if (visible !== oldVisible) {
                        oldVisible = visible;
                        if (typeof callback === "function") {
                            callback(visible);
                        }
                    }
                };
            }
        }
    };
}

function thorInViewContainer(utilsService) {
    return {
        restrict: "A",
        controller: "thorInViewContainer.controller",
        link: (scope, elem) => {
            const latencyValue = 250;
            const throttleOptions = {
                leading: false,
                trailing: true
            };
            const containerEvents = "wheel mousewheel DomMouseScroll touchmove";
            const windowEvents = "ready resize mouseup keydown touchend";
            const containerThrottledCallback = throttle(
                broadcastUpdate,
                latencyValue,
                throttleOptions
            );
            const placeholderThrottledCallback = throttle(
                broadcastPlaceholderUpdate,
                latencyValue,
                throttleOptions
            );
            const windowThrottledCallback = throttle(
                broadcastUpdate,
                latencyValue,
                throttleOptions
            );

            if (utilsService.isMobile) {
                elem.on("scroll", containerThrottledCallback);
            } else {
                elem.on(containerEvents, containerThrottledCallback);
                elem.on("scroll", placeholderThrottledCallback);
            }

            angular.element(window).on(windowEvents, windowThrottledCallback);

            scope.$on("$destroy", cleanEvents);

            function broadcastUpdate() {
                scope.$broadcast("inview.update");
            }

            function broadcastPlaceholderUpdate() {
                scope.$broadcast("inview.placeholder-update");
            }

            function cleanEvents() {
                elem.off(containerEvents, containerThrottledCallback);
                elem.off("scroll", placeholderThrottledCallback);
                angular.element(window).off(windowEvents, windowThrottledCallback);
            }
        }
    };
}

class ThorInViewContainerController {
    public static $inject: string[] = [
        "$element"
    ];
    public $element;

    constructor(
        $element
    ) {
        this.$element = $element;
    }
}

thorInview.$inject = ["$parse"];
thorInViewContainer.$inject = ["utilsService"];

angular
    .module("thor.core.inview.directive", [])
    .controller("thorInViewContainer.controller", ThorInViewContainerController)
    .directive("thorInView", thorInview)
    .directive("thorInViewContainer", thorInViewContainer);
